// extracted by mini-css-extract-plugin
export default {"pageInfo":"PageInfoV1_pageInfo__klWrU","header":"PageInfoV1_header__wuV2+","line":"PageInfoV1_line__K8Oef","textBox":"PageInfoV1_textBox__lC9ed","image":"PageInfoV1_image__bHuJr"};